//Styles
import '../../styles/navigation.css';
//Icons
import { IoIosSearch } from "react-icons/io";
import { FiSearch } from "react-icons/fi";

const SearchBox = ({
    handleSubmit,
    onChange,
    search,
})=>{

    return(
        <div className='form-searchbox'>
                <div className='container-searchbox'>
                        <input 
                            className='searchbox-input'
                            type="search"
                            name="search"
                            onChange={e => onChange(e)}
                            value={search}
                            required
                            placeholder="Que buscas hoy?"
                        />
                    <button
                        type="submit"
                        className='searchbox-submit'
                        onClick={handleSubmit}
                    >
                        <FiSearch className='search-icon' />
                    </button>
                </div>
        </div>
    )
}

export default SearchBox